import { api } from './api';
import type { ImageLabelsSidecar, LabelConfidence } from '@sr-test-wizard/shared';

export interface CriticalFileItem {
  filename: string;
  sha1: string | null;
  version: string | null;
  path: string | null;
  resolvedPath: string | null;
  duplicates: string[];
  status: 'found' | 'missing' | 'duplicate';
}

export interface CriticalFilesResult {
  source: 'texec' | 'manifest' | 'hashes';
  manifestPath?: string;
  total: number;
  found: number;
  missing: number;
  duplicates: number;
  items: CriticalFileItem[];
}

export interface TreeNode {
  name: string;
  path: string;
  type: 'file' | 'directory';
  size?: number;
  children?: TreeNode[];
}

export interface RunImage {
  name: string;
  path: string;
  size: number;
  mtime: string;
  url: string;
}

export interface FileReadResult {
  path: string;
  size: number;
  binary: boolean;
  content: string | null;
}

export interface ImagesAnalysisResult {
  exists: boolean;
  content: string | null;
}

export const runAssetsApi = {
  loadCriticalFilesFromTexec: (runId: string) =>
    api.get<CriticalFilesResult>(`/api/runs/${runId}/critical-files`),
  loadCriticalFilesFromManifest: (runId: string, manifestPath: string) =>
    api.post<CriticalFilesResult>(`/api/runs/${runId}/critical-files/from-manifest`, {
      manifestPath,
    }),
  loadFileTree: (runId: string) =>
    api.get<TreeNode | null>(`/api/runs/${runId}/files/tree`),
  readFile: (runId: string, path: string) =>
    api.get<FileReadResult>(`/api/runs/${runId}/files/read?path=${encodeURIComponent(path)}`),
  listImages: (runId: string) =>
    api.get<{ imagesPath: string | null; items: RunImage[] }>(`/api/runs/${runId}/images`),
  loadImagesAnalysis: (runId: string) =>
    api.get<ImagesAnalysisResult>(`/api/runs/${runId}/images/analysis`),
  loadImageLabels: (runId: string) =>
    api.get<ImageLabelsSidecar>(`/api/runs/${runId}/image-labels`),
  imageUrl: (runId: string, name: string): string =>
    `/api/runs/${runId}/images/serve?path=${encodeURIComponent(name)}`,
};

export type { ImageLabelsSidecar, LabelConfidence };
